export default __webpack_public_path__ + "static/media/notebook.db586b69.svg";